// Shared admin form input styling
export const inp = "w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-[#F26522]/50 placeholder-slate-500";
